export const ANALYZED_STATUS_ALIASES = ["analyzed", "complete", "completed", "verified"] as const;
export const TRANSCRIPT_PROCESSING_STATUSES = ["uploaded", "scrubbed"] as const;

export const TRANSCRIPT_ANALYZED_STATUS_ALIASES = ANALYZED_STATUS_ALIASES;

export const COACH_REVIEWABLE_ANALYSIS_STATUSES = [...TRANSCRIPT_ANALYZED_STATUS_ALIASES] as const;

export function isCoachReviewableAnalysisStatus(status: string | null | undefined): boolean {
  return Boolean(
    status &&
      COACH_REVIEWABLE_ANALYSIS_STATUSES.includes(
        status as (typeof COACH_REVIEWABLE_ANALYSIS_STATUSES)[number]
      )
  );
}

export const LEADER_ANALYSIS_VISIBLE_STATUSES = [...TRANSCRIPT_ANALYZED_STATUS_ALIASES] as const;

export function isTranscriptAnalyzedStatus(status: string | null | undefined): boolean {
  return Boolean(
    status &&
      TRANSCRIPT_ANALYZED_STATUS_ALIASES.includes(
        status as (typeof TRANSCRIPT_ANALYZED_STATUS_ALIASES)[number]
      )
  );
}

export function isLeaderAnalysisVisibleStatus(status: string | null | undefined): boolean {
  return Boolean(
    status &&
      LEADER_ANALYSIS_VISIBLE_STATUSES.includes(
        status as (typeof LEADER_ANALYSIS_VISIBLE_STATUSES)[number]
      )
  );
}

export function isTranscriptProcessingStatus(status: string | null | undefined): boolean {
  return Boolean(
    status &&
      TRANSCRIPT_PROCESSING_STATUSES.includes(
        status as (typeof TRANSCRIPT_PROCESSING_STATUSES)[number]
      )
  );
}

export function isCoachVerifiedTranscriptStatus(
  status: string | null | undefined,
  coachVerified: boolean | null | undefined
): boolean {
  return status === "verified" || coachVerified === true;
}

export function isTranscriptNeedsCoachReview(
  status: string | null | undefined,
  coachVerified: boolean | null | undefined
): boolean {
  return isCoachReviewableAnalysisStatus(status) && !isCoachVerifiedTranscriptStatus(status, coachVerified);
}
